import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function ImageLine({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M21 18L9.24319 11.1419C9.09988 11.0583 8.91823 11.0818 8.80092 11.1991L3 17"
                stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <circle cx="16.5" cy="8.5" r="1.5" stroke={color} strokeWidth="2"/>
            <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2"/>
        </svg>
    );
}

export default ImageLine;
